

export const getNoteColor = (note) => {
    const noteColors = {
        'C': '#817',
        'C#': '#a35',
        'D': '#c66',
        'D#': '#e94',
        'E': '#ed0',
        'F': '#9d5',
        'F#': '#4d8',
        'G': '#2cb',
        'G#': '#0bc',
        'A': '#09c',
        'A#': '#36b',
        'B': '#639'
    };

    return noteColors[note] || '#FFFFFF'; // Default to white if note not found
}

export const getColorBasedOnDegree = (note, scale) => {
    const colors = {
        0: '#ed0',
        1: '#76ff61',
        2: '#00bbf9',
        3: '#e94',
        4: '#8338ec',
        5: '#a35',
        6: '#f15bb5'
    }
    const noteIndex = scale.indexOf(note);

    return colors[noteIndex];
}